export default __webpack_public_path__ + "static/media/logo-trustpilot-5-0-stars.dd3f8aae.svg";